<template>
  <div>
    <h1 class="common__main-title">Student send mail</h1>

    <div v-if="stage === 'template'" id="page-select-template">
      <h4>1. Select template</h4>
      <hr class="mb-4">
      <SelectMailTemplate mode="student" v-model="template" @next="toStudentsStage" />
    </div>

    <div v-if="stage === 'students'" id="page-select-students">
      <h4>2. Extract students condition</h4>
      <hr class="mb-4">
      <SelectStudents v-model="studentsConditions"
        @back="stage = 'template'" @next="stage = 'mail'" />
    </div>

    <div v-if="stage === 'mail'" id="page-input-mail-contents">
      <h4>3. Edit email contents</h4>
      <hr class="mb-4">
      <InputMailContents v-model="mailContents" :name="template.name"
        @back="stage = 'students'" @next="stage = 'confirm'" />
    </div>

    <div v-if="stage === 'confirm'" id="page-confirm">
      <h4 class="mb-4">4. Confirm &amp; send mail</h4>

      <div class="row mb-4">
        <div class="col">
          <h5>Template</h5>
          <hr class="mt-0">
          <div class="row">
            <div class="form-group col-4">
              <label>Name</label>
              <div>{{ template.name }}</div>
            </div>
            <div class="form-group col-4">
              <label>Notification type</label>
              <div>{{ template.notification | notificationType }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <h5>Students condition</h5>
          <hr class="mt-0">
          <h6>Conditions</h6>
          <div class="row">
            <SelectStudents v-model="studentsConditions" :isConfirm="true"
              @back="stage = 'template'" @next="stage = 'mail'" />
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <h5>Email contents</h5>
          <hr class="mt-0">
          <div class="row">
            <div class="form-group col">
              <label>Send date</label>
              <div v-if="mailContents.isImmediately">Immediately</div>
              <div v-else>{{ mailContents.datetime.format('YYYY/MM/DD HH:mm') }}</div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label>Subject</label>
              <div>{{ mailContents.subject }}</div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <label>Text</label>
              <div style="white-space:pre-wrap;">{{ mailContents.body }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <b-button pill variant="secondary" class="mr-2" @click="stage = 'mail'">
          Back
        </b-button>
        <b-button pill variant="primary" @click="register">
          Register
        </b-button>
      </div>
    </div>

    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import { Student, StudentConditions } from '@/store/students/types'
import { MailTemplate } from '@/store/mails/templates/types'
import {
  MailForRegisterToStudent,
  MailNotifications,
  mailNotificationType,
} from '@/store/mails/types'
import SelectMailTemplate from '@/components/parts/mails/sendBulk/SelectMailTemplate.vue'
import SelectStudents from '@/components/parts/mails/sendBulk/SelectStudents.vue'
import InputMailContents, { MailContents } from '@/components/parts/mails/sendBulk/InputMailContents.vue'
import Loading from '@/components/parts/modal/Loading.vue'

type stageType = 'template' | 'students' | 'mail' | 'confirm'

export default Vue.extend({
  components: {
    SelectMailTemplate,
    SelectStudents,
    InputMailContents,
    Loading,
  },

  filters: {
    notificationType: (type: mailNotificationType): string => MailNotifications[type],
  },

  data: (): {
    stage: stageType
    template: MailTemplate|undefined
    studentsConditions: StudentConditions|undefined
    mailContents: MailContents
    isLoading: boolean
  } => ({
    stage: 'template',
    template: undefined,
    studentsConditions: undefined,
    mailContents: {
      datetime: null,
      isImmediately: false,
      subject: '',
      body: '',
    },
    isLoading: false,
  }),

  methods: {
    /**
     * 履修者編集画面に移動（準備含む）
     */
    toStudentsStage() {
      this.mailContents.subject = this.template?.subject || ''
      this.mailContents.body = this.template?.body || ''
      this.stage = 'students'
    },
    /**
     * メール送信登録
     */
    async register() {
      if (this.isLoading) {
        return
      }
      this.isLoading = true

      try {
        const mail: MailForRegisterToStudent = {
          studentConditions: this.studentsConditions,
          sendDate: this.mailContents.isImmediately ? null : this.mailContents.datetime,
          subject: this.mailContents.subject,
          body: this.mailContents.body,
        }

        this.isLoading = false

        await this.$store.dispatch('registerMailToStudent', mail)
        this.isLoading = false
        await this.$bvModal.msgBoxOk('Success !')
        this.$router.push({ name: 'Mails' })
      } catch (error: any) {
        this.isLoading = false
        const message = _.has(error, 'response') ? error.response.data.message : error.message
        this.$bvModal.msgBoxOk(message)
      }
    },
  },
})
</script>

<style scoped>

</style>
